import { type SortDirection, Table } from '@factorialco/deprecated-design-system'

import { columns } from 'modules/finance/components/TaxType/columns'

interface Props {
  onSort: (attribute: string, direction: SortDirection) => void
  attribute: string
  direction: SortDirection
}

const Header = ({ onSort, attribute, direction }: Props) => {
  return (
    <Table.Head>
      <Table.Row>
        {[columns.amount, columns.description].map((column) => (
          <Table.SortableHeadCell
            key={column.id}
            attribute={column.attribute}
            colSpan={column.colSpan}
            onSort={onSort}
            sortAttribute={attribute}
            sortDirection={direction}
          >
            {column.name()}
          </Table.SortableHeadCell>
        ))}
      </Table.Row>
    </Table.Head>
  )
}

export default Header
